import { css } from 'lit-element';
/* @internal */
export const styles = css`:host{--padding: calc(var(--cds-token-space-size-6, 0.6rem) - var(--border-width, .05rem))
    calc(
      var(--cds-token-space-size-6, 0.6rem) - var(--cds-token-space-size-2, 0.1rem) -
        var(--border-width, .05rem)
    )}.private-host{min-width:0}::slotted(a){--color: inherit;display:inline-block;height:auto}
`;
